var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReviews = function SvgReviews(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35293 2.80005H17.6471C18.3943 2.80005 19 3.40409 19 4.15297C19 9.12061 14.9717 13.15 10 13.15C5.02944 13.15 1 9.1217 1 4.15005C1 3.40577 1.60404 2.80005 2.35293 2.80005Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8 13.15H8.20004V16.3454C7.17301 16.5539 6.39999 17.4619 6.39999 18.5504V19.0004H13.6V18.5504C13.6 17.4619 12.827 16.5539 11.8 16.3454V13.15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20004 13.15V12.4C7.78583 12.4 7.45004 12.7358 7.45004 13.15H8.20004ZM11.8 13.15H12.55C12.55 12.7358 12.2143 12.4 11.8 12.4V13.15ZM8.20004 16.3454L8.34923 17.0804C8.69881 17.0095 8.95004 16.7021 8.95004 16.3454H8.20004ZM6.39999 19.0004H5.64999C5.64999 19.4146 5.98578 19.7504 6.39999 19.7504V19.0004ZM13.6 19.0004V19.7504C14.0142 19.7504 14.35 19.4146 14.35 19.0004H13.6ZM11.8 16.3454H11.05C11.05 16.7021 11.3013 17.0095 11.6508 17.0804L11.8 16.3454ZM8.20004 13.9H11.8V12.4H8.20004V13.9ZM8.95004 16.3454V13.15H7.45004V16.3454H8.95004ZM7.14999 18.5504C7.14999 17.8256 7.66485 17.2193 8.34923 17.0804L8.05086 15.6104C6.68117 15.8884 5.64999 17.0981 5.64999 18.5504H7.14999ZM7.14999 19.0004V18.5504H5.64999V19.0004H7.14999ZM13.6 18.2504H6.39999V19.7504H13.6V18.2504ZM12.85 18.5504V19.0004H14.35V18.5504H12.85ZM11.6508 17.0804C12.3352 17.2194 12.85 17.8256 12.85 18.5504H14.35C14.35 17.0982 13.3189 15.8885 11.9493 15.6104L11.6508 17.0804ZM11.05 13.15V16.3454H12.55V13.15H11.05Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59998 2.35C4.59998 1.60442 5.20439 1 5.94998 1H14.05C14.7956 1 15.4 1.60442 15.4 2.35V9.1C15.4 12.0823 12.9823 14.5 9.99998 14.5C7.01764 14.5 4.59998 12.0823 4.59998 9.1V2.35Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 8.82485L8.68175 9.49016C8.38931 9.63775 8.19765 9.50322 8.25337 9.19139L8.50514 7.78223L7.43861 6.78426C7.20202 6.56288 7.27608 6.34633 7.60224 6.30083L9.07615 6.09524L9.73531 4.81314C9.88153 4.52873 10.119 4.52943 10.2648 4.81314L10.924 6.09524L12.3979 6.30083C12.7248 6.34644 12.7975 6.56342 12.5615 6.78426L11.495 7.78223L11.7468 9.19139C11.8026 9.50399 11.6101 9.63739 11.3184 9.49016L10.0001 8.82485Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReviews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reviews.d244c23f.svg";
export { ForwardRef as ReactComponent };